import * as actionTypes from "./supportdeskSettingsTypes";

const INITIAL_STATE = {
    ticketViewList: [],
    ticketViewDropdownList: [],
    ticketViewFieldList: [],
    ticketStatusList: [],
    ticketPriorityList: [],
    ticketTypeList: [],
    ticketTagList: [],
    ticketHistoryList: [],
    ticketNotificationList: [],
    macroList: [],
    macroActionList: [],
    macroPlaceholderList: [],
    automationList: [],
};

const supportdeskSettingsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETTICKETVIEWLIST:
            return {
                ...state,
                ticketViewList: action.payload.list,
            };
        case actionTypes.SETTICKETVIEWDROPDOWNLIST:
            return {
                ...state,
                ticketViewDropdownList: action.payload.list,
            };
        case actionTypes.SETTICKETVIEWFIELDLIST:
            return {
                ...state,
                ticketViewFieldList: action.payload.list,
            };
        case actionTypes.SETTICKETSTATUSLIST:
            return {
                ...state,
                ticketStatusList: action.payload.list,
            };
        case actionTypes.SETTICKETTAGLIST:
            return {
                ...state,
                ticketTagList: action.payload.list,
            };
        case actionTypes.SETTICKETPRIORITYLIST:
            return {
                ...state,
                ticketPriorityList: action.payload.list,
            };
        case actionTypes.SETTICKETTYPELIST:
            return {
                ...state,
                ticketTypeList: action.payload.list,
            };
        case actionTypes.SETTICKETHISTORYSETTINGLIST:
            return {
                ...state,
                ticketHistoryList: action.payload.list,
            };
        case actionTypes.SETTICKETNOTIFICATIONSETTINGLIST:
            return {
                ...state,
                ticketNotificationList: action.payload.list,
            };
        case actionTypes.SETMACROLIST:
            return {
                ...state,
                macroList: action.payload.list,
            };
        case actionTypes.SETMACROACTIONLIST:
            return {
                ...state,
                macroActionList: action.payload.list,
            };
        case actionTypes.SETMACROPLACEHOLDERLIST:
            return {
                ...state,
                macroPlaceholderList: action.payload.list,
            };
        case actionTypes.SETAUTOMATIONLIST:
            return {
                ...state,
                automationList: action.payload.list,
            };
        default:
            return state;
    };
};

export default supportdeskSettingsReducer;